import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import { request } from 'src/editor/shared/utils/request'

export interface UserData {
  id: string
  firstName: string
  lastName: string
  dashboardLocale: PageLocaleEnum
}

export const fetchUserData = async (): Promise<UserData> => {
  const response = await request.get('/api/dashboard/user/user-data')
  return response.data
}
